import React, { useState, useEffect, useContext, useRef } from 'react';
import './fotogalerie_svatby_desktop.css';
import './fotogalerie_svatby_mobile.css';
import NavbarDesktop from "../../navbar/navbar-desktop.tsx";
import Footer from "../../footer/footer.tsx";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


import MenuMobile from "../../../komponenty/navbar-mobile/menu.js";
// ikony
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaGooglePlus } from "react-icons/fa";

import 'animate.css';



function Fotogalerie_svatby() {
  return (
    <div>

{/* mobile sekce */}
      <div className='mobile-vypnuti'>

          <div id="menu-mobile-main">
            <MenuMobile />
          </div>

{/* navbar */}
        <div id='cely-navbar' className='cely-navbar'>
            <img className='fotogalerie-svatby-main-fotka-1' alt='Venkovní svatební obřad s dřevěným obloukem a květinami' src='./img/svatby/svatby-17.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební tabule se zelenými ubrousky a květinovou výzdobou' src='./img/svatby/svatby-8.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Místa nevěsty a ženicha s květinovou girlandou' src='./img/svatby/svatby-22.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Exteriér Hospůdky pod Rablinů se svatebními koktejlovými stolky' src='./img/svatby/svatby-11.jpg'></img>

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Detail svatebního prostírání se sklenkami prosecca' src='./img/svatby/svatby-12.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Dlouhá svatební tabule v sále s krbem' src='./img/svatby/svatby-24.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební obřad na louce před venkovním pódiem' src='./img/svatby/svatby-10.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Slavnostně prostřená svatební tabule se svícny' src='./img/svatby/svatby-16.jpg'></img>

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Prostírání se svatebním menu a lučními květinami' src='./img/svatby/svatby-15.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební tabule s tmavě zeleným tylem a růžemi' src='./img/svatby/svatby-13.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební hosté na zahradě Hospůdky pod Rablinů' src='./img/svatby/svatby-9.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Váza s lučními květinami na svatební tabuli' src='./img/svatby/svatby-19.jpg'></img>

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Prostírání nevěsty se svatebním menu' src='./img/svatby/svatby-23.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Večerní svatební tabule s nazdobeným porcelánem' src='./img/svatby/svatby-14.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Detail svatebního prostírání se jmenovkou a menu' src='./img/svatby/svatby-18.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební tabule se svícnem a karafou s citrusy' src='./img/svatby/svatby-20.jpg'></img>

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Prostírání ženicha s lněným ubrouskem a menu' src='./img/svatby/svatby-25.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Večerní svatební tabule nasvícená svícny' src='./img/svatby/svatby-26.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Detail večerní svatební tabule' src='./img/svatby/svatby-21.jpg'></img>

{/*  ------------------------------------------------------------------------------ */}

<img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-1'></img>

          <div className='navar-pozadi'>
            <h1 className='hospudka-pod-rablinu-nazev-1 animate__animated animate__backInLeft'>Hospůdka pod Rablinů</h1>
            <h3 className='hospudka-pod-rablinu-nazev-2 animate__animated animate__backInLeft'>Ta pravá chuť Valašska</h3>
          </div>
      
          <img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-2'></img>

          <div id="menu-mobile-externi">
            <MenuMobile />
          </div>

        </div>
{/* konec navbaru */}

      
<div className='fotogalerie-mobile-pozadi-2'>
  <h1 className='jidelni-liskte-main-text-1'>Fotogalerie</h1>


  <div className="jidelni-listek-container">
    <ul className="jidelni-listek-odkazy">
      <li><a href='#'>Svatby</a></li>
      <li><a href='#polevky'>Ubytování</a></li>
      <li><a href='#lehke-menu'>Restaurace & menu</a></li>
      <li><a href='#regionalni-speciality'>Akce</a></li>

      <li><a href='#salaty'>Exteriér a okolí</a></li>
      <li><a href='#bezmase-menu'>Naše speciality</a></li>
      <li><a href='#sladke-menu'>Sladký bar</a></li>
      <li><a href='#sefkuchar-doporucuje'>Rauty</a></li>
      <li><a href='#sefkuchar-doporucuje'>Duo Jamaha</a></li>

    </ul>
  </div>


  <img className='fotogalerie-svatby-main-fotka-1' alt='Svatební fotografie z Hospůdky pod Rablinů' src='./img/svatby.jpg'></img>
  <img className='svatby-main-fotka-2' alt='Svatební obřad venku' src='./img/svatby-venku-1.jpg'></img>
  <img className='svatby-main-fotka-3' alt='Svatební hostina vevnitř' src='./img/svatby-vevnitr-1.jpg'></img>

  {/* <p className='fotogalerie-svatby-text-pod-img'><b>Březen, </b> 2024</p> */}

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Svatební fotografie' src='./img/svatby/svatby-1.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební fotografie' src='./img/svatby/svatby-2.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební fotografie' src='./img/svatby/svatby-3.jpg'></img>


  {/* <p className='fotogalerie-svatby-text-pod-img'><b>Červenec, </b> 2024</p> */}

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Svatební fotografie' src='./img/svatby/svatby-4.jpg'></img>
  <img className='fotogalerie-svatby-main-fotka-2' alt='Svatební fotografie' src='./img/svatby/svatby-5.jpg'></img>
  <img className='svatby-main-fotka-2' alt='Svatební fotografie' src='./img/svatby/svatby-6.jpg'></img>
  <img className='svatby-main-fotka-3' alt='Svatební fotografie' src='./img/svatby/svatby-7.jpg'></img>

  {/* <p className='fotogalerie-svatby-text-pod-img'><b>Březen, </b> 2024</p> */}

{/*  ------------------------------------------------------------------------------ */}

  <img className='fotogalerie-svatby-main-fotka-1' alt='Svatební fotografie' src='./img/svatby/svatby-6.jpg'></img>
  <img className='svatby-main-fotka-2' alt='Svatební fotografie' src='./img/svatby/svatby-4.jpg'></img>
  <img className='svatby-main-fotka-3' alt='Svatební fotografie' src='./img/svatby/svatby-1.jpg'></img>

  {/* <p className='fotogalerie-svatby-text-pod-img'><b>Březen, </b> 2024</p> */}

{/*  ------------------------------------------------------------------------------ */}


<img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-fotogalerie-1'></img>

      <h1 className='hospudka-pod-rablinu-kontaktni-informace'>Kontaktní informace</h1>
      <img src='./img/obrazek-hpr-2.PNG' alt='Logo Hospůdka pod Rablinů' className='hospudka-pod-rablinu-logo-3'></img>


      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>Telefon</h1>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-3'>+420 608 608 101</h3>


      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>E-maily</h1>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-4'>info@hospudkapodrablinu.cz</h3>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-5'>ubytovani@hospudkapodrablinu.cz</h3>
      <h3 className='hospudka-pod-rablinu-kontaktni-informace-5'>wellness@hospudkapodrablinu.cz</h3>

      <h1 className='hospudka-pod-rablinu-kontaktni-informace-2'>Sociální sítě</h1>


      <div className="socialni-site-odkazy">
        <a target='blank' href="#"><FaInstagram /></a>
        <a target='blank' href="#"><FaFacebook /></a>
        <a target='blank' href="#"><FaYoutube /></a>
        <a target='blank' href="#"><FaGooglePlus /></a>
      </div>


      <img src='./img/stuha2.png' alt='' className='hospudka-pod-rablinu-stuha-6'></img>

      <h3 className='chraneno-autorskými-právy'>© 2020 - 2026 GAMPEIROS s.r.o.</h3>

    
  </div>



      </div>
    </div>
    
  );
}

export default Fotogalerie_svatby;
